module.exports = __webpack_public_path__ + "img/car.da09dbc6.png";